import React from 'react';
import type { ClientId } from '../data/clients';
type ClientLogoProps = {
  id: ClientId;
};
export function ClientLogo({
  id
}: ClientLogoProps) {
  switch (id) {
    case 'haertel':
      return <svg viewBox="0 0 150 44" className="h-11 w-auto" aria-hidden="true" data-id="element-64" data-mp="ctv56pwufr83">
          <path d="M8 18 L40 6 L72 18" fill="none" stroke="#9b2c2c" strokeWidth="2.2" strokeLinejoin="round" data-id="element-65" data-mp="7vtm44zf3rwm" />
          <path d="M44 14 H140" stroke="#9b2c2c" strokeWidth="1.2" data-id="element-66" data-mp="3uhww0kgh8oy" />
          <text x="8" y="30" fontFamily="Georgia, serif" fontSize="7" letterSpacing="2.5" fill="#6b6b73" data-id="element-67" data-mp="3rlzcdcism11">
            KFZ-WERKSTATT
          </text>
          <text x="58" y="38" fontFamily="Georgia, serif" fontSize="20" fontWeight="700" fill="#2a2a30" data-id="element-68" data-mp="3q27za1pv3xty">
            Härtel
          </text>
        </svg>;
    case 'nordictrail':
      return <svg viewBox="0 0 170 44" className="h-11 w-auto" aria-hidden="true" data-id="element-69" data-mp="1o8ihvf0wo7s8">
          <path d="M4 34 L18 12 L26 23 L33 14 L46 34 Z" fill="#1f5a3d" data-id="element-70" data-mp="1jagzkwbb0cht" />
          <path d="M14 18 L18 12 L22 18 L19 17 Z M30 18 L33 14 L36 18 L33 17.5 Z" fill="#ffffff" data-id="element-71" data-mp="wpzlfs2eshci" />
          <text x="54" y="29" fontFamily="'Inter Tight', Inter, sans-serif" fontSize="17" fontWeight="800" letterSpacing="1.2" fill="#1f5a3d" data-id="element-72" data-mp="11p2s1gy1evml">
            NORDICTRAIL
          </text>
        </svg>;
    case 'holzwerkstatt':
      return <svg viewBox="0 0 180 44" className="h-11 w-auto" aria-hidden="true" data-id="element-73" data-mp="1fhimvugsbncf">
          <rect x="3" y="4" width="36" height="36" rx="2" fill="#a0672f" data-id="element-74" data-mp="1kg3lxqkaw0za" />
          <g fontFamily="'Inter Tight', Inter, sans-serif" fontSize="8.5" fontWeight="700" fill="#ffffff" letterSpacing="0.5" data-id="element-75" data-mp="15qnzunvpsjpx">
            <text x="8" y="15" data-id="element-76" data-mp="1aoz9axi3ks7m">HOLZ</text>
            <text x="8" y="25" data-id="element-77" data-mp="1anxymu4zu7qf">WERK</text>
            <text x="8" y="35" data-id="element-78" data-mp="1yflduesw7ucv">STATT</text>
          </g>
          <text x="48" y="28" fontFamily="'Inter Tight', Inter, sans-serif" fontSize="17" fontWeight="600" fill="#5c3a1a" data-id="element-79" data-mp="1ye0n709p8vka">
            Holzwerkstatt
          </text>
          <text x="160" y="28" fontFamily="'Inter Tight', Inter, sans-serif" fontSize="17" fontWeight="800" fill="#a0672f" data-id="element-80" data-mp="2d0zacj1ix3t7">
            DH
          </text>
        </svg>;
    case 'sycotec':
      return <svg viewBox="0 0 130 44" className="h-11 w-auto" aria-hidden="true" data-id="element-81" data-mp="24012fpnysc5c">
          <path d="M4 15 L12 22 L4 29 Z" fill="#e8730c" data-id="element-82" data-mp="1z32bffzlklbd" />
          <text x="16" y="29" fontFamily="'Inter Tight', Inter, sans-serif" fontSize="19" fontWeight="700" fill="#4a4f59" data-id="element-83" data-mp="1z4lrb5hccucm">
            Syco
          </text>
          <circle cx="100" cy="22" r="19" fill="#4a4f59" data-id="element-84" data-mp="1pbo6gsovmtau" />
          <text x="84" y="29" fontFamily="'Inter Tight', Inter, sans-serif" fontSize="19" fontWeight="700" fill="#ffffff" data-id="element-85" data-mp="1kd3grn793s0n">
            Tec
          </text>
        </svg>;
  }
}